/* eslint max-len: 0 */

import calculationParser from './calculation-parser';

const identity = a => a;

const createSet = (symbols, keyParser, valueParser) => {
  const cards = {};

  symbols.forEach(sym => {
    cards[keyParser(sym)] = valueParser(sym);
  });

  return {
    model: 'simple',
    cards
  };
};

export const createCardset = (symbols, parser) => createSet(symbols, parser, identity);
export const createCardsetResult = (symbols, parser) => createSet(symbols, parser, parser);

export const createCalculationCardset = symbols => createSet(symbols, calculationParser, identity);
export const createCalculationResultCardset = symbols => createSet(symbols, calculationParser, calculationParser);
